import { render, staticRenderFns } from "./Triangle5.vue?vue&type=template&id=098371aa&"
import script from "./Triangle5.vue?vue&type=script&lang=js&"
export * from "./Triangle5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports